import React from "react";
import { IS_REF_MOBILE } from "../../../utils/refViewport";
import { MY_BETS_LIMIT, scrollToMyBets } from "../../../utils/casinoMyBets";

/**
 * Common layout for casino table pages — reference markup (allpanel9 admin):
 * .detail-page-container > .center-main-container >
 *   .center-content > .casino-container > .casino-table.{tableClass} > children
 *   .right-sidebar > div > .casino-right-sidebar > rightSide
 *   (reference "mobile", window < 1280 at load: no simplebar div around .casino-right-sidebar)
 * Layout comes from the ported reference rules in styles/index.css.
 */
export default function CasinoTableLayout({ children, rightSide, tableClass = "" }) {
  // My Bets count for the mobile shortcut, read from the <MyBet bets> element passed as rightSide
  const betCount = React.isValidElement(rightSide) && Array.isArray(rightSide.props.bets) ? rightSide.props.bets.length : 0;
  return (
    <div className="detail-page-container">
      <div className="center-main-container">
        <div className="center-content">
          <div className="casino-container">
            <div className={`casino-table ${tableClass}`.trim()}>{children}</div>
          </div>
        </div>
        {rightSide != null && (
          <div className="right-sidebar">
            {IS_REF_MOBILE ? (
              <>
                <div className="casino-right-sidebar">{rightSide}</div>{" "}
                {/* Reference "mobile": bet-count shortcut to My Bets (hidden ≥1280px by .d-none-desktop) */}
                <div
                  className="market-show-icon d-none-desktop"
                  onClick={() => scrollToMyBets()}
                >
                  {/* counts what the card lists (latest 10), not every bet */}
                  <div className="bet-cnt">{Math.min(betCount, MY_BETS_LIMIT)}</div>{" "}
                  <div className="bet-title">Bets</div>
                </div>
              </>
            ) : (
              <div>
                <div className="casino-right-sidebar">{rightSide}</div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
